<!-- TITLE -->
<div *ngIf="!isNull; else nullCase" class="mb-4 mb-lg-5 row">
    <div class="col col-lg-6">
        <h3 class="causes-tabs-intro-heading fs-5 fs-md-3 fw-500 lh-sm text-maroon">
            {{ mainArticle?.title }}
        </h3>
        <p class="mb-2 fs-md-18 text-link" [innerHtml]="mainArticle?.bodyText"></p>
        <p class="fs-md-18" *ngIf="subArticle" [innerHtml]="subArticle?.bodyText"></p>
    </div>
</div>

<ng-template #nullCase>
    <h3 class="causes-tabs-intro-heading fs-5 fs-md-3 fw-500 lh-sm text-maroon">
        {{ nullArticle?.title }}
    </h3>
    <p [innerHtml]="nullArticle?.bodyText"></p>
</ng-template>

<!-- DESKTOP -->
<div class="tabs-container d-none d-lg-flex d-print-none" *ngIf="articles?.length > 0 && !isNull">
    <!-- TABS -->
    <ul ngbNav #desktopNav="ngbNav" [(activeId)]="activeTabIndex" [animation]="false" class="causes-nav nav flex-column">
        <li *ngFor="let article of articles; let i = index" [ngbNavItem]="i" class="nav-item fs-5">
            <button ngbNavLink class="nav-link d-flex justify-content-center align-items-center" type="button">
                {{ article.title }}
            </button>
            <ng-template ngbNavContent>
                <ng-container
                    [ngTemplateOutlet]="articlePanel"
                    [ngTemplateOutletContext]="{ article: article, imageUrl: articleImageUrl(article), imageAlt: articleImageAlt(article) }"
                ></ng-container>
            </ng-template>
        </li>
    </ul>

    <!-- TAB CONTENT -->
    <div [ngbNavOutlet]="desktopNav" class="content"></div>
</div>

<!-- MOBILE -->
<mobile-panel-list
    class="d-print-none"
    rootClass="mobile-panel-list--center pt-2"
    buttonClass="d-flex align-items-center"
    [items]="articles || []"
    *ngIf="articles?.length > 0 && !isNull"
>
    <ng-template #mobilePanelContent let-article>
        <h4 class="text-blue fw-bold fs-5 pt-1 mb-4">{{ article.title }}</h4>

        <div class="d-flex justify-content-center pb-2" *ngIf="articleImageUrl(article) as imageUrl">
            <img class="w-100 rounded-3" [src]="imageUrl" [alt]="articleImageAlt(article)" />
        </div>

        <div embeddedHTML [innerHtml]="article.bodyText" class="mt-4 fs-6 text-link"></div>
    </ng-template>
</mobile-panel-list>

<!-- ng-bootstrap only creates the active tab panel. Render every article for print so
     information is not omitted based on the tab that happened to be selected. Keep
     the print markup independent of the screen-only tab columns and scroll sizing. -->
<div class="d-none d-print-block" *ngIf="articles?.length > 0 && !isNull">
    <article *ngFor="let article of articles">
        <h4>{{ article.title }}</h4>
        <div class="d-print-flex align-items-start gap-3">
            <div class="text-link flex-grow-1" embeddedHTML [innerHTML]="article.bodyText"></div>
            <img
                *ngIf="articleImageUrl(article) as imageUrl"
                class="causes-tabs-print-image d-block flex-shrink-0 h-auto w-auto object-fit-contain"
                [src]="imageUrl"
                [alt]="articleImageAlt(article)"
            />
        </div>
    </article>
</div>

<ng-template #articlePanel let-article="article" let-imageUrl="imageUrl" let-imageAlt="imageAlt">
    <h4 class="text-blue fs-22">{{ article.title }}</h4>
    <div class="row mt-4 scroll-area" [style.max-height]="scrollHeight + 'px'">
        <div class="left-side col-12 col-xl-5" *ngIf="imageUrl">
            <img [style.max-height]="imgMaxHeight + 'px'" class="mb-3 mb-xl-0" [src]="imageUrl" [alt]="imageAlt" />
        </div>
        <div class="right-side col-12 text-link" [ngClass]="{ 'col-xl-7': imageUrl }" embeddedHTML [innerHTML]="article.bodyText"></div>
    </div>
</ng-template>
